import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useMemo, useState } from 'react';
import { Modal, ModalBody, Row } from 'react-bootstrap';
import ModalHeader from '../../../components/ModalHeader';
import Tabs from '../../../components/Tabs/Tabs';
import {
  addOrRemoveDaysToGivenDate,
  addOrRemoveYearsToGivenDate,
  DateFormats,
  formatDate,
  formatPrice,
} from '../../../utils/utils';
import FormsOfPaymentContent from './tabs/FormsOfPaymentContent';
import NewEstimateTab from './tabs/newEstimateTab';
import OnSaveContent from './tabs/onSaveContent';
import SavedEstimatesTab from './tabs/savedEstimatesTab';

export type customPensionEstimateModalProps = React.PropsWithoutRef<{
  showModal: boolean;
  handleClose: () => void;
}>;

const formsOfPaymentData1 = [
  {
    title: 'Single Life Anuity',
    contributionsWithdrawn: {
      monthlyPayment: formatPrice(3565.0, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      monthlyPaymentToBeneficiary: formatPrice(0, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
    },
    contributionsIncluded: {
      monthlyPayment: formatPrice(11719.58, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      monthlyPaymentToBeneficiary: formatPrice(0, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
    },
  },

  {
    title: '50% Joint & Survivor',
    contributionsWithdrawn: {
      monthlyPayment: formatPrice(2512.0, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      monthlyPaymentToBeneficiary: formatPrice(1256.0, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
    },
    contributionsIncluded: {
      monthlyPayment: formatPrice(9887.42, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      monthlyPaymentToBeneficiary: formatPrice(4918.71, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
    },
  },

  {
    title: '66 2/3% Joint & Survivor',
    contributionsWithdrawn: {
      monthlyPayment: formatPrice(2247.212, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      monthlyPaymentToBeneficiary: formatPrice(1582.65, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
    },
    contributionsIncluded: {
      monthlyPayment: formatPrice(9887.42, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      monthlyPaymentToBeneficiary: formatPrice(4918.71, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
    },
  },

  {
    title: '75% Joint & Survivor',
    contributionsWithdrawn: {
      monthlyPayment: formatPrice(1994.6, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      monthlyPaymentToBeneficiary: formatPrice(1582.65, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
    },
    contributionsIncluded: {
      monthlyPayment: formatPrice(9887.42, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      monthlyPaymentToBeneficiary: formatPrice(4918.71, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
    },
  },

  {
    title: '100% Joint & Survivor',
    contributionsWithdrawn: {
      monthlyPayment: formatPrice(1782.5, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      monthlyPaymentToBeneficiary: formatPrice(1782.5, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
    },
    contributionsIncluded: {
      monthlyPayment: formatPrice(9887.42, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      monthlyPaymentToBeneficiary: formatPrice(4918.71, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
    },
  },

  {
    title: '5 Year Certain & Continuous',
    contributionsWithdrawn: {
      monthlyPayment: formatPrice(2822, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      monthlyPaymentToBeneficiary: formatPrice(1582.65, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
    },
    contributionsIncluded: {
      monthlyPayment: formatPrice(9887.42, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      monthlyPaymentToBeneficiary: formatPrice(4918.71, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
    },
  },

  {
    title: '10 Year Certain & Continuous',
    contributionsWithdrawn: {
      monthlyPayment: formatPrice(2243, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      monthlyPaymentToBeneficiary: formatPrice(1582.65, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
    },
    contributionsIncluded: {
      monthlyPayment: formatPrice(9887.42, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      monthlyPaymentToBeneficiary: formatPrice(4918.71, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
    },
  },

  {
    title: '15 Year Certain & Continuous',
    contributionsWithdrawn: {
      monthlyPayment: formatPrice(1876, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      monthlyPaymentToBeneficiary: formatPrice(1582.65, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
    },
    contributionsIncluded: {
      monthlyPayment: formatPrice(9887.42, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      monthlyPaymentToBeneficiary: formatPrice(4918.71, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
    },
  },

  {
    title: '5 Year Certain',
    contributionsWithdrawn: {
      monthlyPayment: formatPrice(3165.29, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      monthlyPaymentToBeneficiary: formatPrice(2582.65, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
    },
    contributionsIncluded: {
      monthlyPayment: formatPrice(2247.12, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      monthlyPaymentToBeneficiary: formatPrice(4918.71, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
    },
  },

  {
    title: '10 Year Certain',
    contributionsWithdrawn: {
      monthlyPayment: formatPrice(1994.6, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      monthlyPaymentToBeneficiary: formatPrice(1582.65, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
    },
    contributionsIncluded: {
      monthlyPayment: formatPrice(9887.42, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      monthlyPaymentToBeneficiary: formatPrice(4918.71, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
    },
  },

  {
    title: '15 Year Certain',
    contributionsWithdrawn: {
      monthlyPayment: formatPrice(1782.5, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      monthlyPaymentToBeneficiary: formatPrice(1582.65, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
    },
    contributionsIncluded: {
      monthlyPayment: formatPrice(9887.42, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      monthlyPaymentToBeneficiary: formatPrice(4918.71, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
    },
  },

  {
    title: '5 Year Modified Cash Refund',
    contributionsWithdrawn: {
      monthlyPayment: formatPrice(2822, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      monthlyPaymentToBeneficiary: formatPrice(1582.65, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
    },
    contributionsIncluded: {
      monthlyPayment: formatPrice(9887.42, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      monthlyPaymentToBeneficiary: formatPrice(4918.71, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
    },
  },

  {
    title: '10 Year Modified Cash Refund',
    contributionsWithdrawn: {
      monthlyPayment: formatPrice(2243, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      monthlyPaymentToBeneficiary: formatPrice(1582.65, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
    },
    contributionsIncluded: {
      monthlyPayment: formatPrice(9887.42, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      monthlyPaymentToBeneficiary: formatPrice(4918.71, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
    },
  },

  {
    title: '15 Year Modified Cash Refund',
    contributionsWithdrawn: {
      monthlyPayment: formatPrice(1876, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      monthlyPaymentToBeneficiary: formatPrice(1582.65, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
    },
    contributionsIncluded: {
      monthlyPayment: formatPrice(9887.42, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
      monthlyPaymentToBeneficiary: formatPrice(4918.71, 'en-US', {
        currency: 'USD',
        style: 'currency',
        minimumFractionDigits: 2,
      }),
    },
  },
];

const savedEstimates = [
  {
    scenario1: {
      whenToStopWorking: formatDate(new Date(), DateFormats.US),
      whenToStartPension: formatDate(
        addOrRemoveDaysToGivenDate(new Date(), 14),
        DateFormats.US
      ),
      birthDate: '2020-01-01',
      percentage: '0',
      dateOfSaving: formatDate(new Date(), DateFormats.US),
      name: 'Estimate 1',
      totalAmount: 417,
    },
    scenario2: {
      whenToStopWorking: formatDate(
        addOrRemoveYearsToGivenDate(new Date(), 5),
        DateFormats.US
      ),
      whenToStartPension: formatDate(
        addOrRemoveYearsToGivenDate(
          addOrRemoveDaysToGivenDate(new Date(), 14),
          5
        ),
        DateFormats.US
      ),
      birthDate: '2020-01-01',
      percentage: '0',
      dateOfSaving: formatDate(new Date(), DateFormats.US),
      name: 'Estimate 1',
      totalAmount: 1347,
    },
    link: `${process.env.PUBLIC_URL}/${'PensionEstimate-DemoExample_v1.pdf'}`,
    target: '_blank',
  },
  {
    scenario1: {
      whenToStopWorking: formatDate(
        addOrRemoveYearsToGivenDate(new Date(), 10),
        DateFormats.US
      ),
      whenToStartPension: formatDate(
        addOrRemoveYearsToGivenDate(
          addOrRemoveDaysToGivenDate(new Date(), 14),
          10
        ),
        DateFormats.US
      ),
      birthDate: '2020-01-01',
      percentage: '0',
      dateOfSaving: formatDate(new Date(), DateFormats.US),
      name: 'Estimate 2',
      totalAmount: 2489,
    },
    link: `${process.env.PUBLIC_URL}/${'PensionEstimate-DemoExample_v1.pdf'}`,
    target: '_blank',
  },
  {
    scenario1: {
      whenToStopWorking: formatDate(
        addOrRemoveYearsToGivenDate(new Date(), 15),
        DateFormats.US
      ),
      whenToStartPension: formatDate(
        addOrRemoveYearsToGivenDate(
          addOrRemoveDaysToGivenDate(new Date(), 14),
          15
        ),
        DateFormats.US
      ),
      birthDate: '2020-01-01',
      percentage: '0',
      dateOfSaving: formatDate(new Date(), DateFormats.US),
      name: 'Estimate 3',
      totalAmount: 3565,
    },
    link: `${process.env.PUBLIC_URL}/${'PensionEstimate-DemoExample_v1.pdf'}`,
    target: '_blank',
  },
];

const PensionEstimateModal = ({
  showModal,
  handleClose,
  ...props
}: customPensionEstimateModalProps) => {
  const [isInline] = useState(true);
  const [currentContent, setCurrentContent] = useState<string>('1');

  const handleBackToResults = () => {
    setCurrentContent('1');
  };

  const handleOnSave = () => {
    setCurrentContent('2');
  };

  const handleFormsOfPayment = () => {
    setCurrentContent('3');
  };

  const newEstimateContent = useMemo(() => {
    switch (currentContent) {
      case '1':
        return (
          <NewEstimateTab
            handleOnSave={handleOnSave}
            handleBackToResults={handleBackToResults}
            isInline={isInline}
            handleFormsOfPayment={handleFormsOfPayment}
          />
        );
      case '2':
        return <OnSaveContent handleBackToResults={handleBackToResults} />;
      case '3':
        return (
          <FormsOfPaymentContent
            tableData={formsOfPaymentData1}
            handleBackToResults={handleBackToResults}
            handleClose={handleClose}
          />
        );
    }
  }, [currentContent, handleClose, isInline]);

  const tabsData = [
    {
      name: 'New Estimate',
      content: newEstimateContent,
      leftIcon: <FontAwesomeIcon icon={light('calculator')} />,
    },
    {
      name: 'Saved Estimates',
      content: <SavedEstimatesTab savedEstimates={savedEstimates} />,
      leftIcon: <FontAwesomeIcon icon={light('rectangle-vertical-history')} />,
    },
  ];

  const handleCloseModal = () => {
    handleClose();
  };

  return (
    <Modal show={showModal} onHide={handleCloseModal} {...props} size="xl">
      <ModalHeader onHide={handleClose} closeButton>
        <h4>Pension Estimate</h4>
      </ModalHeader>
      <ModalBody>
        <Row>
          <Tabs tabs={tabsData} variant={'horizontal'} />
        </Row>
      </ModalBody>
    </Modal>
  );
};

export default PensionEstimateModal;
